import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthorizeService } from 'src/app/core/auth/authorize.service';
import { ResourcesService } from 'src/app/shared/services/resources.service';

@Component({
  selector: 'app-not-authorized',
  templateUrl: './not-authorized.component.html',
  styleUrls: ['./not-authorized.component.css']
})

export class NotAuthorizedComponent implements OnInit, OnDestroy {

  resourceKeyValue: any;
  lblNotAuthorizedInstruction1 = "Some Error Occurred";
  lblNotAuthorizedInstruction2 = "Please check the logs or contact your system administrator.";

  constructor(
    private authorizeService: AuthorizeService,
    private resourcesService: ResourcesService
    ) {}

  ngOnInit() {

    this.resourcesService.bsObject.subscribe(result => {
      result && (this.resourceKeyValue = result);
      this.setControlValues();

    });

    this.authorizeService.isAuthorizeSubject.next(false);

  }

  ngOnDestroy(): void {
    this.authorizeService.isAuthorizeSubject.next(true);
  }

  setControlValues(): void {
    this.lblNotAuthorizedInstruction1 = this.lblNotAuthorizedInstruction1 ? this.lblNotAuthorizedInstruction1:  this.resourceKeyValue.lblNotAuthorizedInstruction1;
    this.lblNotAuthorizedInstruction2 = this.lblNotAuthorizedInstruction2 ? this.lblNotAuthorizedInstruction2: this.resourceKeyValue.lblNotAuthorizedInstruction2;
  }
}
